import React from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import Central from './Central';
import Loading from '../../Loading';
import ErrorMessage from '../../Error';
import { GET_CENTRAL_DATA } from './central.gql';

const DATA_POLL_INTERVAL = 1000;

export const GET_CURRENT_USER = gql`
query {
    currentUser {
      id
      username
      name
    }
}
`;

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}));

export default function CentralView(props) {
  const classes = useStyles();

  let centralID = props.centralID;

  if(centralID === undefined) {
    centralID = props.match.params.centralID;
  }

  return (
    <div className={classes.root}>
        <Query query={GET_CURRENT_USER} pollInterval={DATA_POLL_INTERVAL}>
        {({ data, error, loading }) => {
            if (error) {
              console.log("error", error);
              return <ErrorMessage error={"Server nicht erreichbar!"} />;
            }
            if(data) {
              // console.log("data");
            }
            return null;
        }}
      </Query>
      <Query query={GET_CENTRAL_DATA} variables={{id: centralID}}>
        {({ data, error, loading }) => {
            if (loading) {
              return <Loading/>;
            }

            if (error) {
              return <ErrorMessage error={error} />;
            }

            if (data !== undefined) {
              return  <Central source={data.central} />;
            }

            return null;
        }}
      </Query>
    </div>
  );
};

CentralView.propTypes = {
    centralID: PropTypes.string,
};
